import React from 'react'
import { useCurrencySymbol } from '../../../../../utils/currencyUtils';
import DateConversion from '../../../../../utils/DateConversion';
import CommaConvert from '../../../../../utils/CommaConvert';
import ProgressTracker from '../../../../../utils/ProgressTracker';


const OPShowCompletedTasksPM = ({
    projectTrackingWorkEntries,
    matchedRowDescription,
    taskKey,
    expenseKey,
    matchedHardwareParts,
    row,
    showListState,
    isViewOnly = false }) => {
    const currency = useCurrencySymbol();
    const { formatDateByCountry } = DateConversion();
    const USAComma = CommaConvert();
    return (
        <div className=' pb-3'>

            {row?.TypeService?.toLowerCase().includes("hardware")
                // {row.TypeService === "Hardware"
                ? showListState === "tasktable" && (
                    <div className="w-full max-h-[24rem] overflow-y-auto overflow-x-hidden">
                        {/* Header */}
                        <div className="sticky top-0 z-[2399] flex text-center bg-[#156082] text-white text-[10px] font-semibold break-all whitespace-normal">
                            <div className="p-1 border border-[#dee2e6] w-[14%] text-center">
                                Part Name
                            </div>
                            <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                Quantity
                            </div>
                            <div className="p-1 border border-[#dee2e6] w-[10%]">Total Price ({currency})</div>
                            <div className="p-1 border border-[#dee2e6] w-[11%] text-center">
                                Start Date
                            </div>
                            <div className="p-1 border border-[#dee2e6] w-[11%]">End Date</div>
                            <div className="p-1 border border-[#dee2e6] w-[44%] text-center">
                                Tracker
                            </div>

                        </div>

                        <div
                            className="flex text-center text-[10px] break-all whitespace-normal max-h-14"
                        >
                            <div className="p-1 border border-[#dee2e6] w-[14%]">
                                {"Total"}
                            </div>

                            <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                {USAComma(matchedHardwareParts?.reduce((sum, item) => sum + (item?.quantity || 0), 0))}                  </div>
                            <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                {USAComma(matchedHardwareParts?.reduce((sum, item) => sum + (item?.totalprice || 0), 0))}
                            </div>
                            <div className="p-1 border border-[#dee2e6] w-[11%] text-center">
                            </div>
                            <div className="p-1 border border-[#dee2e6] w-[11%] text-center">
                            </div>
                            <div className="p-2.5 border border-[#dee2e6] w-[44%] text-center">
                                {matchedHardwareParts?.every((entry) => entry?.isTaskComplete) ? (
                                    <>
                                        <ProgressTracker value={100} />
                                    </>
                                ) : (
                                    <>
                                        {(() => {
                                            const allEntries = matchedHardwareParts?.length;
                                            const completedEntriesCount = matchedHardwareParts?.filter(entry => entry.isTaskComplete).length;
                                            const trackerPercentage = allEntries > 0 ? (completedEntriesCount / allEntries) * 100 : 0;
                                            return <ProgressTracker value={trackerPercentage} />;
                                        })()}
                                    </>
                                )}
                            </div>

                        </div>

                        {/* Rows */}
                        {matchedHardwareParts?.length > 0 ? (
                            matchedHardwareParts?.map((entry, index) => (
                                <div
                                    key={entry}
                                    className="flex text-center text-[10px] break-all whitespace-normal max-h-14 cursor-default"
                                >
                                    <div className="p-1 border border-[#dee2e6] w-[14%] max-h-14 overflow-auto"
                                        title={`${entry.assemblepartdescription}`}
                                    >
                                        {entry.assemblepartdescription}
                                    </div>
                                    <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                        {entry.quantity || ""}
                                    </div>
                                    <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                        {USAComma(entry.totalprice) || ""}
                                    </div>
                                    <div className="p-1 border border-[#dee2e6] w-[11%] text-center">
                                        {entry.startdate
                                            ? formatDateByCountry(entry.startdate)
                                            : ""}
                                    </div>
                                    <div className="p-1 border border-[#dee2e6] w-[11%] text-center">
                                        {entry.enddate
                                            ? formatDateByCountry(entry.enddate)
                                            : ""}
                                    </div>
                                    <div className="p-2.5 border border-[#dee2e6] w-[44%] text-center">
                                        <ProgressTracker value={entry.isTaskComplete ? 100 : 0} />
                                    </div>

                                </div>
                            ))
                        ) : (
                            <div className="flex text-[14px] break-all whitespace-normal max-h-14 p-1">
                                <p className="text-red-500 text-center">
                                    {" "}
                                    No Tracking Task Entries Found
                                </p>
                            </div>
                        )}
                    </div>

                ) : showListState === "tasktable" && (
                    <>
                        <div className="w-full max-h-[24rem] overflow-y-auto overflow-x-hidden">
                            {/* Header */}
                            <div className="sticky top-0 z-[2399] flex text-center bg-[#156082] text-white text-[10px] font-semibold break-all whitespace-normal">
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                    Tasks
                                </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                    Hours Assigned
                                </div>{" "}
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                    Hours Spent
                                </div>{" "}
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                    Start Date
                                </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%]">End Date</div>
                                <div className="p-1 border border-[#dee2e6] w-[10%]">Notes</div>
                                <div className="p-1 border border-[#dee2e6] w-[40%] text-center">
                                    Tracker
                                </div>

                            </div>
                            <div
                                className="flex text-center text-[10px] break-all whitespace-normal max-h-14"
                            >
                                <div className="p-1 border border-[#dee2e6] w-[10%]">
                                    {"Total"}
                                </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%]">
                                    {projectTrackingWorkEntries?.reduce((sum, item) => sum + (item?.hoursassigned || 0), 0)}
                                </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                    {projectTrackingWorkEntries?.reduce((sum, item) => sum + (item?.hoursspent || 0), 0)}
                                </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                </div>
                                <div className="p-2.5 border border-[#dee2e6] w-[40%] text-center">
                                    {projectTrackingWorkEntries?.every((entry) => entry?.isTaskComplete) ? (
                                        <>
                                            <ProgressTracker value={100} />
                                        </>
                                    ) : (
                                        <>
                                            {(() => {
                                                const hoursAssigned = projectTrackingWorkEntries?.reduce((sum, item) => sum + (item?.hoursassigned || 0), 0);
                                                const hoursSpent = projectTrackingWorkEntries?.reduce((sum, item) => sum + (item?.hoursspent || 0), 0);
                                                const trackerPercentage = hoursAssigned > 0 ? (hoursSpent / hoursAssigned) * 100 : 0;
                                                return <ProgressTracker value={trackerPercentage} />;
                                            })()}
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Rows */}
                            {projectTrackingWorkEntries.length > 0 ? (
                                projectTrackingWorkEntries.map((entry, index) => (
                                    <div
                                        key={entry}
                                        className="flex  text-[10px] text-center break-all whitespace-normal max-h-14 cursor-default"
                                    >
                                        <div className="p-1 border border-[#dee2e6] w-[10%] overflow-auto max-h-14"
                                            title={`${entry.task}`}
                                        >
                                            {entry.task || ""}
                                        </div>
                                        <div className="p-1 border border-[#dee2e6] w-[10%]">
                                            {entry.hoursassigned || ""}
                                        </div>
                                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                            {entry.hoursspent || ""}
                                        </div>
                                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                            {entry.startdate
                                                ? formatDateByCountry(entry.startdate)
                                                : ""}                       </div>
                                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                            {entry.enddate
                                                ? formatDateByCountry(entry.enddate)
                                                : ""}                       </div>
                                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center max-h-14 overflow-auto"
                                            title={`${entry.notes}`}
                                        >
                                            {entry.notes}
                                        </div>

                                        <div className="p-2.5 border border-[#dee2e6] w-[40%] text-center">
                                            {entry?.isTaskComplete ? (
                                                <ProgressTracker
                                                    value={100}
                                                />
                                            ) : (
                                                <ProgressTracker
                                                    value={Math.max(
                                                        0,
                                                        Number(entry?.hoursassigned) > 0
                                                            ? ((Number(entry?.hoursspent) || 0) /
                                                                Number(entry?.hoursassigned)) *
                                                            100
                                                            : 0
                                                    )}
                                                />
                                            )}

                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="flex text-[14px] break-all whitespace-normal max-h-14 p-1">
                                    <p className="text-red-500 text-center">
                                        {" "}
                                        No Tracking Task Entries Found
                                    </p>
                                </div>
                            )}
                        </div>
                    </>
                )}


            {showListState === "otherexpenses" && (
                <div className="w-full max-h-[24rem] overflow-y-auto overflow-x-hidden">
                    <div className="sticky top-0 z-[2399] flex bg-[#156082] text-white text-[10px] font-semibold break-all whitespace-normal">
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                            Description
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                            Amount ({currency})
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                            Start Date
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[10%]">End Date</div>
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                            Notes
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                            Expenses ({currency})
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[40%] text-center">
                            Tracker
                        </div>
                    </div>

                    <div
                        className="flex text-center text-[10px] break-all whitespace-normal max-h-14"
                    >
                        <div className="p-1 border border-[#dee2e6] w-[10%]">
                            {"Total"}
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                            {USAComma(matchedRowDescription?.reduce((sum, item) => sum + (item?.value || 0), 0))}
                        </div>

                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                        </div>
                        <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                            {USAComma(matchedRowDescription.reduce((sum, item) => sum + (item?.expenses || 0), 0))}
                        </div>
                        <div className="p-2.5 border border-[#dee2e6] w-[40%] text-center">
                            {matchedRowDescription?.every((entry) => entry?.isTaskComplete) ? (
                                <>
                                    <ProgressTracker value={100} />
                                </>
                            ) : (
                                <>
                                    {(() => {
                                        const allEntries = matchedRowDescription?.reduce((sum, item) => sum + (item?.value || 0), 0);
                                        const completedEntriesCount = matchedRowDescription?.reduce((sum, item) => sum + (item?.expenses || 0), 0);
                                        const trackerPercentage = allEntries > 0 ? (completedEntriesCount / allEntries) * 100 : 0;
                                        return <ProgressTracker value={trackerPercentage} />;
                                    })()}
                                </>
                            )}
                        </div>
                    </div>

                    {matchedRowDescription?.length > 0 ? (
                        matchedRowDescription?.map((entry, index) => (
                            <div
                                key={entry}
                                className="flex text-[10px] break-all whitespace-normal max-h-14 text-center cursor-default"
                            >
                                <div className="p-1 border border-[#dee2e6] w-[10%] max-h-14 overflow-auto"
                                    title={`${entry.description}`}
                                >
                                    {entry.description || ""}
                                </div>
                                <div className="p-1 border text-center border-[#dee2e6] w-[10%]">
                                    {USAComma(entry.value) || ""}
                                </div>

                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                    {entry.startdate
                                        ? formatDateByCountry(entry.startdate)
                                        : ""}                   </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center">
                                    {entry.enddate
                                        ? formatDateByCountry(entry.enddate)
                                        : ""}                   </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%] text-center overflow-auto max-h-14"
                                    title={`${entry.notes}`}
                                >
                                    {entry.notes || ""}
                                </div>
                                <div className="p-1 border border-[#dee2e6] w-[10%]">
                                    {USAComma(entry.expenses) || ""}
                                </div>
                                <div className="p-2.5 border border-[#dee2e6] w-[40%] text-center">
                                    <ProgressTracker value={entry.isTaskComplete ? 100 : 0} />
                                </div>

                            </div>
                        ))
                    ) : (
                        <div className="flex text-[14px] break-all whitespace-normal max-h-14 p-1">
                            <p className="text-red-500 text-center">
                                {" "}
                                No Tracking Task Entries Found
                            </p>
                        </div>
                    )}
                </div>
            )}
        </div>)
}

export default OPShowCompletedTasksPM